import React, { useState, useEffect } from 'react';
import config from 'config';


const ProductDocumentation = ({ isActive, isDisabled, onClick }) => {
    const [showTooltip, setShowTooltip] = useState(false);

  return (
    <div
    style={{
      position: 'relative',
      display: 'inline-block',
      
    }}
    onMouseEnter={() => setShowTooltip(true)}
    onMouseLeave={() => setShowTooltip(false)}
  >
     {showTooltip && (
        <div
          style={{
            position: 'absolute',
            top: '50%',
            right: '110%',
            transform: 'translateY(-50%)',
            backgroundColor: 'black',
            color: 'white',
            padding: '6px 10px',
            borderRadius: '5px',
            fontSize: '12px',
            whiteSpace: 'nowrap',
            zIndex: 999,
          }}
        >
          Product Documentation
          <div
            style={{
              position: 'absolute',
              top: '50%',
              left: '100%',
              transform: 'translateY(-50%)',
              width: 0,
              height: 0,
              borderTop: '6px solid transparent',
              borderBottom: '6px solid transparent',
              borderLeft: '6px solid black',
            }}
          />
        </div>
      )}
      <button       
        //  onClick={() => onClick?.()}
         style={{ 
            color: 'white',
            backgroundColor: 'white',
            border: 'none',
            cursor: 'pointer',
            color: isActive ? '#fff' : '#555',
            opacity: isDisabled ? 0.4 : 1
          }}
      >
        <a href={`${config.RootUrl}/modules/helpdesk/#/help/productDocumentation`} target="_blank" rel="noopener noreferrer" >
            <img src={`${process.env.PUBLIC_URL}/assets/images/Product-document.svg`} alt="Product-document" style={{ width: 18, height: 18}}  />
        </a>
      </button>
    </div>
  );
};

export default ProductDocumentation;